import type { TrackingFeature } from '@shared/types/tracking.ts';
import { isBlackFridaySliderItem, isProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { ProductItem, TileItem, TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
import { blackFridaySliderFeatures } from '@tilelist/domain/tracking/SliderTracking.ts';

const PARENT_TILELIST_FEATURE: TrackingFeature = { id: 'find_tilelist_1', name: 'tilelist', status: 'visible' };

export function featureIdFromLocalListPosition(localListPosition: number): string {
    return 'find_tile_' + localListPosition;
}

export function featureFromTrackableTileItem(item: TileItem): TrackingFeature {
    if (item.type === 'BrandTile') {
        return {
            name: 'tile',
            id: featureIdFromLocalListPosition(item.localListPosition),
            position: item.localListPosition,
            status: 'loaded',
            parentId: PARENT_TILELIST_FEATURE.id,
            labels: {
                san_ProductType: ['brand'],
            },
        };
    }

    return featureFromProductItem(item);
}

export function featureFromProductItem(productItem: ProductItem): TrackingFeature {
    const { ...featureTracking } = productItem.product.featureTracking ?? {};

    const productType = { san_ProductType: [productItem.product.productType] };
    return {
        name: 'tile',
        id: featureIdFromLocalListPosition(productItem.localListPosition),
        position: productItem.localListPosition,
        variationId: productItem.product.bestVariationId,
        status: 'loaded',
        parentId: PARENT_TILELIST_FEATURE.id,
        labels: {
            ...featureTracking,
            ...productType,
        },
    };
}

export function featuresFromTileListItems(tileListItems: TileListItem[]): TrackingFeature[] {
    const tileFeatures = tileListItems
        .filter((item): item is TileItem => isProductItem(item) || item.type === 'BrandTile')
        .map((item) => featureFromTrackableTileItem(item));
    const sliderFeatures = tileListItems.flatMap((item) =>
        isBlackFridaySliderItem(item) ? blackFridaySliderFeatures(item) : [],
    );
    return [PARENT_TILELIST_FEATURE, ...tileFeatures, ...sliderFeatures];
}
